import { render } from "./AboBox.vue?vue&type=template&id=022aa329"
import script from "./AboBox.vue?vue&type=script&lang=ts"
export * from "./AboBox.vue?vue&type=script&lang=ts"

import "./AboBox.vue?vue&type=style&index=0&id=022aa329&lang=scss"
script.render = render

export default script